import { TagManagerProvider } from '../../services/ads/adapters'
import { AnalyticsConfiguration } from '../analytics/analytics-configuration'
import { Entity } from '../entity'
import { EntityBuilder } from '../entity/builder'
import { AdsConfiguration } from './ads'
import { IdentityConfiguration } from './identity'
import { PageConfiguration } from './page'

export interface IConfiguration {
    ads?: AdsConfiguration
    analytics?: AnalyticsConfiguration
    identity?: IdentityConfiguration
    page?: PageConfiguration
}

/**
 * For eventual use in JSON schema(s) for attributes etc. required by services.
 */
export interface IDOMConf {
    attr: {
        [_: string]: {
            key: string
            value?: string | {
                [_: string]: string
            }
        }
    }
}

export class Configuration extends Entity implements IConfiguration {
    public ads: AdsConfiguration
    public analytics: AnalyticsConfiguration
    public identity: IdentityConfiguration
    public page: PageConfiguration

    public constructor(configuration: any) {
        super()

        if (configuration && configuration.ads) {
            this.ads = EntityBuilder.buildOne<AdsConfiguration>(AdsConfiguration, configuration.ads)
        }

        if (configuration && configuration.analytics) {
            this.analytics = EntityBuilder
                .buildOne<AnalyticsConfiguration>(AnalyticsConfiguration, configuration.analytics)
            // TODO: Remove when Krus conf moved from Ads conf
            if (this.ads && this.ads.tags && !this.analytics.tags.krux) {
                const kruxTag = this.ads.tags.find((_) => _.client === TagManagerProvider.KRUX)
                if (kruxTag) {
                    this.analytics.tags.krux = kruxTag.account
                }
            }
        }

        if (configuration && configuration.identity) {
            this.identity = EntityBuilder.buildOne<IdentityConfiguration>(IdentityConfiguration, configuration.identity)
        }

        this.page = EntityBuilder.buildOne<PageConfiguration>(PageConfiguration, configuration.page || {})
    }
}
